// extracted by css-extract-rspack-plugin
export default {"footer":"CGhJqE93g_EUxbNM","footerButton":"PTsN5zKttCMf9VXj"};